import { HttpTypes } from '@/types';
import {
  AdminCheckPaymentResponse,
  AdminCreateShippingRatesResponse,
  AdminOrderCreateResponse,
} from '@/types/http';
import { BaseOrder, BaseOrderDetail, BaseStats } from '@/types/http/orders/common';
import { AxiosInstance } from 'axios';

class Orders {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async list(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseOrder[]>> {
    const result = await this.client.get('/orders/internal/order', {
      params: queryParams,
    });
    return result.data;
  }

  async get(id: string): Promise<HttpTypes.IResponse<BaseOrderDetail>> {
    const result = await this.client.get(`/orders/internal/order/${id}`);
    return result.data;
  }

  async create(
    data: HttpTypes.AdminCreateOrder
  ): Promise<HttpTypes.IResponse<AdminOrderCreateResponse>> {
    const result = await this.client.post('/orders/internal/order', data);
    return result.data;
  }

  async update(
    data: HttpTypes.AdminUpdateOrder
  ): Promise<HttpTypes.IResponse<AdminOrderCreateResponse>> {
    const result = await this.client.put(`/orders/internal/order/${data.order_id}`, data);
    return result.data;
  }

  async listArea(queryParams: HttpTypes.FindParams): Promise<HttpTypes.StoreAreaResponse> {
    const result = await this.client.get('/sites/shipping/area', {
      params: queryParams,
    });
    return result.data;
  }

  async listShippingCategory(): Promise<HttpTypes.StoreShippingCategoryResponse> {
    const result = await this.client.get('/sites/shipping/service-category');
    return result.data;
  }

  async createRates(
    data: HttpTypes.AdminCreateShippingRates,
    locationId?: string
  ): Promise<HttpTypes.IResponse<AdminCreateShippingRatesResponse>> {
    const result = await this.client.post('/sites/shipping/rates', data, {
      headers: {
        'X-Location-Id': locationId as string,
      },
    });
    return result.data;
  }

  async listStats(queryParams: HttpTypes.FindParams): Promise<HttpTypes.IResponse<BaseStats>> {
    const result = await this.client.get('/orders/internal/order/summary/stats', {
      params: queryParams,
    });
    return result.data;
  }

  async updateStatusOrder(data: HttpTypes.AdminUpdateStatusOrder): Promise<void> {
    await this.client.put(`/orders/internal/order/update/status`, data);
  }

  async checkPaymentOrder(id: string): Promise<HttpTypes.IResponse<AdminCheckPaymentResponse>> {
    const result = await this.client.get(`/orders/internal/order/payment/check/${id}`);
    return result.data;
  }
}

export default Orders;
